export function AboutSection() {
  return (
    <div className="settings-section">
      <p className="settings-eyebrow">About</p>
      <p className="settings-about-title">Paul's Calendar</p>
      <p className="settings-desc" style={{ marginBottom: 0 }}>
        A self-hosted calendar app. Built with Bun, Hono, and Kalendus.
      </p>
    </div>
  );
}
